import type { KeyboardEvent, MouseEvent } from 'react';

/**
 * Props that make a whole row or card open something, while the controls inside it (an audience
 * picker, a grant button) keep doing their own job.
 */
export const activatableProps = (onActivate?: () => void) => {
  if (!onActivate) return {};

  return {
    tabIndex: 0,
    onClick: (event: MouseEvent<HTMLElement>) => {
      const control = (event.target as HTMLElement).closest('button, a, input, select, label');
      if (control && event.currentTarget.contains(control)) return;
      onActivate();
    },
    onKeyDown: (event: KeyboardEvent<HTMLElement>) => {
      if (event.target !== event.currentTarget) return;
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      onActivate();
    },
  };
};
